import * as React from 'react'

import { styled } from 'next-yak'
import * as Redux from 'react-redux'

import * as env from '@owl-nest/config'
import * as plume from '@ulule/owl-kit-components/next'

import * as projectModel from '../../models/project'
import { RootState } from '../../../reducers'

export function Description(): React.ReactElement {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const lang = env.useUserEnv().lang

  return (
    <DescriptionWrapper>
      <StyledWysiwygContent dangerouslySetInnerHTML={{ __html: project?.coming_soon?.description?.[lang] ?? '' }} />
    </DescriptionWrapper>
  )
}

const DescriptionWrapper = styled.div`
  margin: 0 auto;
  max-width: 80%;
  width: fit-content;

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    max-width: 753px;
    min-width: 753px;
    margin: 58px auto 0 auto;
  }
`

const StyledWysiwygContent = styled(plume.WysiwygContent)`
  p {
    ${plume.styles.copy.styles.L.light};
  }

  h2 {
    ${plume.styles.heading.styles.XL};
  }

  h3 {
    ${plume.styles.heading.styles.L};
  }

  h4 {
    ${plume.styles.heading.styles.M};
  }
`
